import {
  Checkbox, CircularProgress, TableBody, TableCell, TableRow 
} from '@mui/material';
import React from 'react';

import CellContent from './cell-contents';

interface BodyProps {
  columnProps: any;
  data: any;
  handleEditChange: (a: any) => void;
  handleEditClick: (a: any) => void; // TODO: edit type
  handleRowClick?: (a: any) => void; // TODO: entity type
  loading: boolean;
  primaryKey: string;
  rowKeyCols?: string[];
  selectable: boolean;
  selected: string;
  activeCell: string;
  edits: any;
  links: () => string;
}

function generateKey(entity, rowKeyCols): string {
  return rowKeyCols.map((key) => entity[key]).join('__');
}

const Body = React.memo(function Body({
  columnProps,
  data,
  handleEditChange,
  handleEditClick,
  handleRowClick,
  loading,
  primaryKey,
  rowKeyCols,
  selectable,
  selected,
  activeCell,
  edits,
  links
}: BodyProps) {
  const className = handleRowClick ? 'cursor-pointer' : '';

  if (loading) {
    return (
      <tbody>
        <tr>
          <td>
            <CircularProgress />
          </td>
        </tr>
      </tbody>
    );
  }

  // TODO: fix on click handler so it's not using arrow function in props
  /* TODO:
    find out if checkbox with data-action works
    interface MySelectDisplayProps extends React.HTMLAttributes<HTMLDivElement> {"data-testid"?: string;}
    inputProps={{data-action:'select'}}
    */
  return (
    <TableBody onClick={handleEditClick}>
      { data.map((entity) => {
        const key = rowKeyCols ? generateKey(entity, rowKeyCols) : entity[primaryKey];
        const handleClick = handleRowClick
          ? () => {
            handleRowClick(entity);
          }
          : undefined;
        const checked = !!selected[entity[primaryKey]];

        return (
          <TableRow key={key} className={className} onClick={handleClick}>
            { selectable && (
              <TableCell>
                <Checkbox data-action="select" checked={checked} value={entity[primaryKey]} />
              </TableCell>
            ) }
            { columnProps
              .filter((p) => p.indexView)
              .map((columnConfig) => {
                const key = columnConfig.key;

                return (
                  <TableCell key={key}>
                    <CellContent
                      activeCell={activeCell}
                      columnConfig={columnConfig}
                      edits={edits}
                      entity={entity}
                      handleEditChange={handleEditChange}
                      links={links}
                      primaryKey={primaryKey}
                    />
                  </TableCell>
                );
              }) }
          </TableRow>
        );
      }) }
    </TableBody>
  );
});

export default Body;
